import React from "react";
import * as L from "lucide-react";

// Catalogue centralisé d'icônes Lucide organisées par catégorie.
// Chaque entrée : { name: "PascalName", label: "Label FR", category: "..." }
// Le nom doit correspondre exactement au composant exporté par lucide-react.
export const ICON_LIBRARY = [
  // --- Contact ---
  { name: "Phone", label: "Téléphone", category: "Contact" },
  { name: "PhoneCall", label: "Appel téléphonique", category: "Contact" },
  { name: "Mail", label: "Email", category: "Contact" },
  { name: "MailOpen", label: "Email ouvert", category: "Contact" },
  { name: "MessageCircle", label: "Message rond", category: "Contact" },
  { name: "MessageSquare", label: "Message carré", category: "Contact" },
  { name: "Send", label: "Envoyer", category: "Contact" },
  { name: "AtSign", label: "Arobase", category: "Contact" },
  { name: "Smartphone", label: "Smartphone", category: "Contact" },
  { name: "Headphones", label: "Casque audio", category: "Contact" },

  // --- Géographie / Localisation ---
  { name: "MapPin", label: "Épingle carte", category: "Géo" },
  { name: "Map", label: "Carte", category: "Géo" },
  { name: "Navigation", label: "Navigation", category: "Géo" },
  { name: "Compass", label: "Boussole", category: "Géo" },
  { name: "Globe", label: "Globe", category: "Géo" },
  { name: "Home", label: "Maison", category: "Géo" },
  { name: "Building", label: "Bâtiment", category: "Géo" },
  { name: "Building2", label: "Immeuble", category: "Géo" },
  { name: "Factory", label: "Usine", category: "Géo" },
  { name: "Store", label: "Magasin", category: "Géo" },
  { name: "Warehouse", label: "Entrepôt", category: "Géo" },

  // --- Temps / Horaires ---
  { name: "Clock", label: "Horloge", category: "Temps" },
  { name: "Clock3", label: "Horloge 3h", category: "Temps" },
  { name: "Timer", label: "Chronomètre", category: "Temps" },
  { name: "Calendar", label: "Calendrier", category: "Temps" },
  { name: "CalendarClock", label: "Calendrier heure", category: "Temps" },
  { name: "CalendarCheck", label: "Calendrier validé", category: "Temps" },
  { name: "AlarmClock", label: "Réveil", category: "Temps" },
  { name: "Hourglass", label: "Sablier", category: "Temps" },

  // --- Sécurité / Certification ---
  { name: "Shield", label: "Bouclier", category: "Sécurité" },
  { name: "ShieldCheck", label: "Bouclier validé", category: "Sécurité" },
  { name: "ShieldAlert", label: "Bouclier alerte", category: "Sécurité" },
  { name: "Lock", label: "Cadenas", category: "Sécurité" },
  { name: "Key", label: "Clé", category: "Sécurité" },
  { name: "BadgeCheck", label: "Badge validé", category: "Sécurité" },
  { name: "Award", label: "Médaille", category: "Sécurité" },
  { name: "Trophy", label: "Trophée", category: "Sécurité" },
  { name: "Crown", label: "Couronne", category: "Sécurité" },
  { name: "Medal", label: "Médaille 2", category: "Sécurité" },
  { name: "CheckCircle2", label: "Check dans cercle", category: "Sécurité" },
  { name: "Verified", label: "Vérifié", category: "Sécurité" },

  // --- Outils / Métier ---
  { name: "Wrench", label: "Clé à molette", category: "Métier" },
  { name: "Hammer", label: "Marteau", category: "Métier" },
  { name: "Cog", label: "Engrenage", category: "Métier" },
  { name: "Settings", label: "Réglages", category: "Métier" },
  { name: "Settings2", label: "Réglages 2", category: "Métier" },
  { name: "HardHat", label: "Casque chantier", category: "Métier" },
  { name: "Drill", label: "Perceuse", category: "Métier" },
  { name: "Screwdriver", label: "Tournevis", category: "Métier" },
  { name: "Ruler", label: "Règle", category: "Métier" },
  { name: "Paintbrush", label: "Pinceau", category: "Métier" },
  { name: "PaintBucket", label: "Pot de peinture", category: "Métier" },
  { name: "Pickaxe", label: "Pioche", category: "Métier" },
  { name: "Pipette", label: "Pipette", category: "Métier" },

  // --- Énergies / Climatisation / Plomberie ---
  { name: "Wind", label: "Vent (climat.)", category: "Énergies" },
  { name: "Droplets", label: "Gouttes (plomberie)", category: "Énergies" },
  { name: "Droplet", label: "Goutte", category: "Énergies" },
  { name: "Flame", label: "Flamme (chauffage)", category: "Énergies" },
  { name: "Snowflake", label: "Flocon (froid)", category: "Énergies" },
  { name: "Thermometer", label: "Thermomètre", category: "Énergies" },
  { name: "ThermometerSun", label: "Thermomètre chaud", category: "Énergies" },
  { name: "ThermometerSnowflake", label: "Thermomètre froid", category: "Énergies" },
  { name: "Sun", label: "Soleil", category: "Énergies" },
  { name: "Cloud", label: "Nuage", category: "Énergies" },
  { name: "CloudRain", label: "Pluie", category: "Énergies" },
  { name: "Zap", label: "Éclair (élec.)", category: "Énergies" },
  { name: "ZapOff", label: "Éclair coupé", category: "Énergies" },
  { name: "Plug", label: "Prise", category: "Énergies" },
  { name: "Battery", label: "Batterie", category: "Énergies" },
  { name: "Leaf", label: "Feuille (éco)", category: "Énergies" },
  { name: "Recycle", label: "Recyclage", category: "Énergies" },
  { name: "Fan", label: "Ventilateur", category: "Énergies" },

  // --- Business / Valeur ---
  { name: "Star", label: "Étoile", category: "Business" },
  { name: "Sparkles", label: "Étincelles", category: "Business" },
  { name: "Heart", label: "Cœur", category: "Business" },
  { name: "ThumbsUp", label: "Pouce levé", category: "Business" },
  { name: "HandshakeIcon", label: "Poignée de main", category: "Business" },
  { name: "Users", label: "Équipe", category: "Business" },
  { name: "User", label: "Utilisateur", category: "Business" },
  { name: "UserCheck", label: "Utilisateur validé", category: "Business" },
  { name: "TrendingUp", label: "Tendance haut", category: "Business" },
  { name: "Target", label: "Cible", category: "Business" },
  { name: "Rocket", label: "Fusée", category: "Business" },
  { name: "Gift", label: "Cadeau", category: "Business" },
  { name: "Gem", label: "Gemme", category: "Business" },
  { name: "Coins", label: "Pièces", category: "Business" },
  { name: "Euro", label: "Euro", category: "Business" },
  { name: "CreditCard", label: "Carte bancaire", category: "Business" },
  { name: "Briefcase", label: "Mallette", category: "Business" },
  { name: "Percent", label: "Pourcent", category: "Business" },
  { name: "Tag", label: "Étiquette", category: "Business" },

  // --- Réseaux sociaux ---
  { name: "Facebook", label: "Facebook", category: "Social" },
  { name: "Instagram", label: "Instagram", category: "Social" },
  { name: "Linkedin", label: "LinkedIn", category: "Social" },
  { name: "Youtube", label: "YouTube", category: "Social" },
  { name: "Twitter", label: "Twitter / X", category: "Social" },
  { name: "Github", label: "GitHub", category: "Social" },
  { name: "Share2", label: "Partager", category: "Social" },

  // --- Actions / UI ---
  { name: "FileText", label: "Document", category: "UI" },
  { name: "ClipboardList", label: "Liste presse-papier", category: "UI" },
  { name: "ClipboardCheck", label: "Liste validée", category: "UI" },
  { name: "BookOpen", label: "Livre ouvert", category: "UI" },
  { name: "Bookmark", label: "Marque-page", category: "UI" },
  { name: "Search", label: "Recherche", category: "UI" },
  { name: "Bell", label: "Cloche notif", category: "UI" },
  { name: "Eye", label: "Œil", category: "UI" },
  { name: "Camera", label: "Appareil photo", category: "UI" },
  { name: "Image", label: "Image", category: "UI" },
  { name: "Video", label: "Vidéo", category: "UI" },
  { name: "Play", label: "Lecture", category: "UI" },
  { name: "Download", label: "Téléchargement", category: "UI" },
  { name: "Upload", label: "Envoi", category: "UI" },
  { name: "ExternalLink", label: "Lien externe", category: "UI" },
  { name: "Info", label: "Info", category: "UI" },
  { name: "HelpCircle", label: "Aide", category: "UI" },
  { name: "AlertCircle", label: "Alerte", category: "UI" },
  { name: "CheckCircle", label: "Validé", category: "UI" },
  { name: "XCircle", label: "Annulé", category: "UI" },
];

// Liste des noms valides pour validation rapide
export const VALID_ICON_NAMES = new Set(ICON_LIBRARY.map(i => i.name));

// Récupère le Component Lucide par nom (avec fallback)
export function getIconComponent(name) {
  if (!name) return L.HelpCircle;
  // Si l'utilisateur a tapé un nom qui existe dans lucide mais pas dans notre library,
  // on le supporte aussi pour rester souple
  return L[name] || L.HelpCircle;
}

// Composant utilitaire : <Icon name="Phone" className="w-5 h-5"/>
export function Icon({ name, className = "", strokeWidth = 2, ...rest }) {
  const Comp = getIconComponent(name);
  return <Comp className={className} strokeWidth={strokeWidth} {...rest} />;
}

// Catégories ordonnées pour le picker
export const ICON_CATEGORIES = [
  "Contact", "Géo", "Temps", "Sécurité", "Métier", "Énergies", "Business", "Social", "UI",
];
